'use strict';

var pxToNumber = require('../../../../../../../../_virtual/pxToNumber.cjs');

var hasRequiredPxToNumber;

function requirePxToNumber () {
	if (hasRequiredPxToNumber) return pxToNumber.__exports;
	hasRequiredPxToNumber = 1;

	/**
	 * Give a px string value, convert it to a number.
	 */ const pxToNumber$1 = (px)=>{
	    const number = parseFloat(px.replace(/px$/, ""));
	    return number;
	};

	pxToNumber.__exports.pxToNumber = pxToNumber$1;
	
	return pxToNumber.__exports;
}

exports.__require = requirePxToNumber;
//# sourceMappingURL=pxToNumber.cjs.map
